module.exports = __webpack_public_path__ + "TB_Powerdown_Ambience_A.wav.87673fd5.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_down/TB_Powerdown_Ambience_A.wav.mp3
// module id = 496
// module chunks = 0